import Vue from 'vue'
import i18next from 'i18next'
import VueI18Next from '@panter/vue-i18next'

import Config from '~/plugins/config'
import Constants from '~/plugins/constants'
import FontAwesome from '~/plugins/font-awesome'

import daDK from '../../public/locales/da-DK'
import nlNL from '../../public/locales/nl-NL'
import noNO from '../../public/locales/no-NO'
import svSE from '../../public/locales/sv-SE'
import en from '../../public/locales/en'

import config from '../../config.json'

// Import style
import '../style/base.scss'

Vue.config.productionTip = false

// Apply plugins
Vue.use(Config)
Vue.use(Constants)
Vue.use(FontAwesome)
Vue.use(VueI18Next)

const locales = {
  da: 'da-DK',
  nl: 'nl-NL',
  no: 'no-NO',
  sv: 'sv-SE',
}

const locale = locales[config.locale]

// Set up translations
let i18nextOptions = {
  lng: locale,
  whitelist: [...Object.values(locales), 'en'],
  resources: {
    en: { translation: en },
    'da-DK': { translation: daDK },
    'nl-NL': { translation: nlNL },
    'no-NO': { translation: noNO },
    'sv-SE': { translation: svSE },
  },
  fallbackLng: ['en'],
}

i18next.init(i18nextOptions)

const i18n = new VueI18Next(i18next)

/**
 * Generates a options object for Vue with the options that are always required to make our pages/components work.
 * @param {boolean=} ignoreVueVars Pass true if vueVars arent' used and thus not required to be set by the server.
 * @returns {!Object}
 */
function generateVueOptions(ignoreVueVars) {
  if (ignoreVueVars) {
    return { i18n }
  }

  return {
    i18n,
    data() {
      // vueVars should always be declared in the .ctp file when using Vue,
      // this check is just to make sure nothing breaks too hard for end users if the variable goes missing.
      try {
        return vueVars
      } catch (err) {
        // eslint-disable-next-line
        console.error(
          'vueVars not found. Make sure you declare a JS variable called vueVars in your .ctp file.'
        )
      }

      return {}
    },
  }
}

export { generateVueOptions }
